import React from 'react'
import styled from 'styled-components'
import {
    formatDateWithDayOfWeek,
    PrimaryChip,
    SecondaryChip,
} from '@tuhi/components'
import { AccForm } from 'app/api/forms/dto/accFormDto'

const Container = styled.div`
    display: flex;
    gap: 16px;
`

interface Props {
    // The only caller (forms review) renders this once the form has loaded.
    form: AccForm
}

export const FormsAuthenticatedHeader: React.FC<Props> = ({ form }) => {
    const consultDate = formatDateWithDayOfWeek(form.sentDate)

    return (
        <Container>
            <PrimaryChip>{consultDate}</PrimaryChip>

            <SecondaryChip>{form.status}</SecondaryChip>
        </Container>
    )
}
